import { ruleDefinitionDefaults, defaultValidationMetafieldRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductVariantMetafieldFromVariantOption",
    title: "Update Variant Metafield From Variant Options",
    description: "Automatically set variant metafield based on a preselected variant option.",
    example: "Selecting the Size option for a clothing item will add the corresponding Size values to each variant",
    additional: ["Products/variants that do not have the selected option will not be affected"],
    legacy: false,
    inProgress: false,
    previewType: "ProductVariantMetafield",
    tags: ["Products", "Variants", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductVariantMetafieldFromVariantOption",
                metafieldType: "single_line_text_field",
                metafieldNamespaceAndKey: null,
                optionName: null,
                skipProductsWithSingleVariant: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationMetafieldRule,
                (rule, errors) => {
                    if (rule.settings.optionName == null || rule.settings.optionName === "") {
                        errors["optionName"] = "Option name is required";
                    }
                },],
            createClashingRulesValidationFunctionNew("PRODUCTVARIANT", "metafieldNamespaceAndKey"));
    }
};

export default ruleDefinition;